<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>Condições Financeiras</b></h5>
        </th>
      </tr>
      <tr>
        <td colspan="4">
          <table class="table table-striped">
            <tbody>
              <tr>
                <td>
                  Renda total da família <br /><strong>{{
                    renda_total_familiar | moedaRS()
                  }}</strong>
                </td>
                <td>
                  Valor da renda média (per capita) da família: <br /><strong>{{
                    per_capita_familiar | moedaRS()
                  }}</strong>
                  <label
                    v-if="
                      per_capita_familiar <=
                      this.$store.state.settings.familia_extrema_pobreza
                    "
                    class="badge badge-danger"
                  >
                    Pobreza
                  </label>
                  <label
                    v-if="
                      per_capita_familiar >
                        this.$store.state.settings.familia_extrema_pobreza &&
                      per_capita_familiar <=
                        this.$store.state.settings.familia_pobreza
                    "
                    class="badge badge-warning"
                    >Pobreza</label
                  >
                  <label
                    v-if="
                      per_capita_familiar >=
                      this.$store.state.settings.familia_perfil_cadunico
                    "
                    class="badge badge-primary"
                  >
                    Perfil Cadunico
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  Renda total da família (incluindo programas sociais): <br />
                  <strong>
                    {{
                      (renda_total_familiar + beneficioValor + programasValor)
                        | moedaRS()
                    }}
                  </strong>
                </td>
                <td>
                  Renda familiar per capita (incluindo programas sociais)<br />
                  <strong>
                    {{
                      (per_capita_familiar + beneficioValor + programasValor)
                        | moedaRS()
                    }}</strong
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <th colspan="4">Despesas mensais da familia</th>
      </tr>
      <tr>
        <td>
          ENERGIA ELÉTRICA: <b>{{ financeiro.val_desp_energia }}</b>
        </td>
        <td>
          ÁGUA E ESGOTO: <b>{{ financeiro.val_desp_agua }}</b>
        </td>
      </tr>
      <tr>
        <td>
          GÁS, CARVÃO E LENHA: <b>{{ financeiro.val_desp_gas }}</b>
        </td>
        <td>
          ALIMENTAÇÃO, HIGIENE E LIMPEZA:
          <b>{{ financeiro.val_desp_alimentacao }}</b>
        </td>
      </tr>
      <tr>
        <td>
          TRANSPORTE: <b>{{ financeiro.val_desp_transporte }}</b>
        </td>
        <td>
          ALUGUEL: <b>{{ financeiro.val_desp_aluguel }}</b>
        </td>
      </tr>
      <tr>
        <td>
          MEDICAMENTOS DE USO REGULAR:
          <b>{{ financeiro.val_desp_medicamentos }}</b>
        </td>
        <td>
          OUTRAS DESPESAS: <b>{{ financeiro.val_desp_outros }}</b>
        </td>
      </tr>
      <tr>
        <th colspan="4">TOTAL DE DESPESAS: {{ sumRendas }}</th>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      per_capita_familiar: 0,
      renda_total_familiar: 0,
      cadastrarFinanceiro: 0,
      show_historico: false,
      beneficioValor: 0,
      beneficios: [],
      programasValor: 0,
      programas: [],
      financeiro: {
        renda_total_familiar: 0,
        per_capita_familiar: 0,
        val_desp_energia: 0,
        val_desp_agua: 0,
        val_desp_gas: 0,
        val_desp_alimentacao: 0,
        val_desp_transporte: 0,
        val_desp_aluguel: 0,
        val_desp_medicamentos: 0,
        val_desp_outros: 0,
        total_desp: 0,
        observacoes_financeiro: null,
      },
    };
  },
  mounted() {
    if (this.item.financeiro != null) {
      this.financeiro = this.item.financeiro;
    }
    if (this.item.beneficiosEventuais != null) {
      this.beneficios = this.item.beneficiosEventuais;
    }
    if (this.item.programas_sociais != null) {
      this.programas = this.item.programas_sociais;
    }
    this.per_capita_familiar = this.item.renda_calculo
      ? parseInt(this.checkValue(this.item.renda_calculo)) /
        this.item.familiares.length
      : parseInt(this.checkValue(this.financeiro.per_capita_familiar)) / 100;

    this.renda_total_familiar = this.item.renda_calculo
      ? this.checkValue(this.item.renda_calculo)
      : this.checkValue(this.financeiro.renda_total_familiar);
  },
  updated() {},
  computed: {
    sumRendas() {
      var sumBeneficio = 0;
      var sumProgramas = 0;

      this.beneficios.forEach((elem) => {
        sumBeneficio += elem.valor;
      });
      this.programas.forEach((elem) => {
        sumProgramas += elem.valor;
      });

      this.beneficioValor = sumBeneficio;
      this.programasValor = sumProgramas;

      var valores = [
        this.checkValue(this.financeiro.val_desp_energia),
        this.checkValue(this.financeiro.val_desp_agua),
        this.checkValue(this.financeiro.val_desp_gas),
        this.checkValue(this.financeiro.val_desp_alimentacao),
        this.checkValue(this.financeiro.val_desp_transporte),
        this.checkValue(this.financeiro.val_desp_aluguel),
        this.checkValue(this.financeiro.val_desp_medicamentos),
        this.checkValue(this.financeiro.val_desp_outros),
      ];

      return (this.financeiro.total_desp = valores.reduce((a, b) => a + b));
    },
  },
  methods: {
    findJob(profissao_principal) {
      const job = this.$root.arrays.profissao_principal.find(
        (element) => element.id == profissao_principal
      );
      return job ? job.value : "";
    },
    changeNome(nome) {
      return nome != undefined || nome != null ? "," + nome : "";
    },
    checkValue(a) {
      return a == null ? 0 : parseInt(a);
    },
    truncate(text, length) {
      if (text.length > length) {
        return text.substring(0, length);
      } else {
        return text;
      }
    },
    submit() {
      this.item.financeiro = this.financeiro;
      this.item.cadastrarFinanceiro = this.cadastrarFinanceiro;
      this.$emit("submit");
    },
  },
};
</script>

<style lang="scss" scoped></style>
